import request from "@/utils/request";

/**
 * 获取弹窗列表
 * 用于判断是否需要弹出功能说明窗口
 * @param params 无需传参
 * @param config 请求配置
 * @returns {Promise}
 */
export function getWindowList(params, config) {
  return request.get("/front/mailWindow/getWindowList", params, config);
}

/**
 * 处理弹窗选择（关闭或不再弹出）
 * @param params { pageType: number, selectType: number }
 *   - pageType: 1-跟进页面，2-群发页面
 *   - selectType: 1-关闭按钮，2-近期不再弹出按钮
 * @param config 请求配置
 * @returns {Promise}
 */
export function selectWindow(params, config) {
  return request.post("/front/mailWindow/selectWindow", params, config);
}
